import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { types as actions, setUserAction } from '../../reducers/actions';
import { UserService } from '../../services';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_USER),
    switchMap(action =>
      UserService.getAll(action.id, store).pipe(
        map(data => {
          return setUserAction(data);
        })
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/users/getUser.js